module.exports = __webpack_public_path__ + "static/media/6j_website_logo_Platinum_hke.aae46a60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6j_website_logo_Platinum_hke.jpg
// module id = 105
// module chunks = 0